type ListOfIds = string[];
type Id = string;
type ContentTypeId = string;
type EntryId = string;
type NodeId = string;
type NodePath = string;
type DependencyIdAndDependencyOfIds = [Id, ListOfIds];

type LanguageString = {
  [key: string]: string;
};

export type Model = {
  dataFormat: 'model';
  id: Id;
  name: LanguageString;
  description?: LanguageString;
  contentTypes?: ListOfIds;
  components?: ListOfIds;
  defaults?: [EntryId, ContentTypeId][];
  nodes?: [NodeId, NodePath][];
  tagGroups?: ListOfIds;
  dependencyOf?: {
    contentTypes?: ListOfIds;
    components?: ListOfIds;
  };
  dependencies?: {
    contentTypes: DependencyIdAndDependencyOfIds[];
    components: DependencyIdAndDependencyOfIds[];
    tagGroups: DependencyIdAndDependencyOfIds[];
  };
};
